import { render } from "./header-comp.vue?vue&type=template&id=f5bbb814&scoped=true"
import script from "./header-comp.vue?vue&type=script&lang=js"
export * from "./header-comp.vue?vue&type=script&lang=js"

import "./header-comp.vue?vue&type=style&index=0&id=f5bbb814&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5bbb814"]])

export default __exports__